import * as React from "react";
import {SafeAreaProvider} from "react-native-safe-area-context";
import {Image, StyleSheet, Text, View} from "react-native";
import {RFPercentage} from "react-native-responsive-fontsize";

export default function ErrorMain({reason}: { reason: any }) {
    return (
        <SafeAreaProvider>
            <View style={styles.errorContainer}>
                <Image
                    style={styles.logo}
                    source={require('../../assets/images/logo-white.png')}
                />
                <View style={styles.separator}/>
                <Text style={styles.errorTitleText}>ERROR! {reason}</Text>
                <View style={styles.separator}/>
                <Text style={styles.errorText}>Possible reasons: </Text>

                <Text style={styles.errorText}>1. Basic Data not entered</Text>
                <Text style={styles.errorText}>2. No internet connection present</Text>
                <Text style={styles.errorText}>3. Error with the server</Text>
            </View>
        </SafeAreaProvider>
    );
}
const styles = StyleSheet.create({
    errorContainer: {
        flex: 1,
        padding: 5,
        backgroundColor: 'red',
        color: 'white',
        textAlign: 'center',
        marginTop: 0,
        textAlignVertical: "center",
        justifyContent: 'center',
    },
    errorTitleText: {
        color: "white",
        fontSize: RFPercentage(3.5),
        textAlign: 'center',
    },
    errorText: {
        textAlign: 'center',
        fontSize: RFPercentage(2),
        color: "white",
    },
    separator: {
        marginVertical: 20,
        height: 2,
        alignSelf: "center",
        width: '80%',
        // backgroundColor:"#ef1a1a"
        backgroundColor: "white"
    },
    logo: {
        alignSelf: "center",
        height: 78,
        width:250,
        // width: 66,
    },
});